var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPackageCardImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 270,
    height: 271,
    viewBox: "0 0 270 271",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-835 -301) translate(835 301)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M15 0h240c8.284 0 15 6.716 15 15v117H0V15C0 6.716 6.716 0 15 0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M45.115 15.923L90.231 69 0 69z",
    transform: "translate(66 32)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9C9C9",
    d: "M91.558 0L138 69 45.115 69z",
    transform: "translate(66 32)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#B6B6B6",
    d: "M12 150H258V163H12zM12 176H193V189H12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M12 206H193V219H12zM12 236H135V249H12z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 269,
    height: 269,
    x: 0.5,
    y: 0.7,
    stroke: "#B6B6B6",
    rx: 15
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackageCardImage);
export default __webpack_public_path__ + "static/media/package-card-image.fc8b16e60854fc982ae93111216cdcb9.svg";
export { ForwardRef as ReactComponent };